import { AddPolicyComponent } from '../../../../../forms/dynamic-forms/add-policy/add-policy.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { Router , RouterModule } from '@angular/router';
import { AddPolicyService } from './../../../../../../_services/forms/create-account/add-policy.service';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';
import { UserService } from './../../../../../../_services/user.service';
import { UserDataService } from './../../../../../../_services/data-services/user-data.service';
import { AddPolicyDataService } from './../../../../../../_services/signup-process-service/add-policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, MapfreModalComponent, MapfreButtonComponent, AddPolicyComponent],
  selector: 'app-add-policy-to-account',
  templateUrl: './add-policy-to-account.component.html',
})
export class AddPolicyToAccountComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  linkPolicy: any[];
  user: any;
  isAcmic: boolean;
  hideModal: boolean;
  continueButton = 'Continue';
  firstName: string;
  emailDoesNotMatch: boolean;
  constructor(
    private router: Router,
    policyService: AddPolicyService,
    private userService: UserService,
    private acmicService: AcmicService,
    private userDataService: UserDataService,
    private addPolicyDataService: AddPolicyDataService
  ) {
    this.linkPolicy = policyService.getLinkInputs();
    this.emailDoesNotMatch = false;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    let modalTranslateCopy = 'LOCATE_YOUR_POLICY_INFORMATION';
    if (this.isAcmic) {
      modalTranslateCopy = 'LOCATE_YOUR_POLICY_INFO';
    }
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.firstName = user.userDetails.firstName;
      }
    });
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small normal-case modal-dialog center-on-page',
      additionalButtonClasses: 'add-policy-btn dm-sans-medium btn-color',
      animatePosition: 'bottom',
      buttonCopy: 'WHERE_CAN_I_FIND_POLICY_INFO',
      modalId: 'helpModal',
      modalTranslateCopy,
      typeOfModal: 'default',
      modalName: 'link-policy_Where_To_Find_Options',
    });
    this.addPolicyDataService.$emailDoesNotMatch.subscribe((policyEmail) => {
      this.emailDoesNotMatch = policyEmail;
    });
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }
}
